module.exports = __webpack_public_path__ + "static/media/o.59e13e62.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/component/sounds/o.mp3
// module id = 104
// module chunks = 0